var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_127_4788",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_127_4788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 25V9C8 8.45 8.19583 7.97917 8.5875 7.5875C8.97917 7.19583 9.45 7 10 7H16C16.55 7 17.0208 7.19583 17.4125 7.5875C17.8042 7.97917 18 8.45 18 9V16H19C19.55 16 20.0208 16.1958 20.4125 16.5875C20.8042 16.9792 21 17.45 21 18V22.5C21 22.7833 21.0958 23.0208 21.2875 23.2125C21.4792 23.4042 21.7167 23.5 22 23.5C22.2833 23.5 22.5208 23.4042 22.7125 23.2125C22.9042 23.0208 23 22.7833 23 22.5V15.3C22.85 15.3833 22.6917 15.4375 22.525 15.4625C22.3583 15.4875 22.1833 15.5 22 15.5C21.3 15.5 20.7083 15.2583 20.225 14.775C19.7417 14.2917 19.5 13.7 19.5 13C19.5 12.4667 19.6458 11.9875 19.9375 11.5625C20.2292 11.1375 20.6167 10.8333 21.1 10.65L19 8.55L20.05 7.5L23.75 11.1C24 11.35 24.1875 11.6417 24.3125 11.975C24.4375 12.3083 24.5 12.65 24.5 13V22.5C24.5 23.2 24.2583 23.7917 23.775 24.275C23.2917 24.7583 22.7 25 22 25C21.3 25 20.7083 24.7583 20.225 24.275C19.7417 23.7917 19.5 23.2 19.5 22.5V17.5H18V25H8ZM10 14H16V9H10V14ZM22 14C22.2833 14 22.5208 13.9042 22.7125 13.7125C22.9042 13.5208 23 13.2833 23 13C23 12.7167 22.9042 12.4792 22.7125 12.2875C22.5208 12.0958 22.2833 12 22 12C21.7167 12 21.4792 12.0958 21.2875 12.2875C21.0958 12.4792 21 12.7167 21 13C21 13.2833 21.0958 13.5208 21.2875 13.7125C21.4792 13.9042 21.7167 14 22 14Z",
    fill: "#686868"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSite);
export default __webpack_public_path__ + "static/media/site.b710577cec2f97a3534ab30470fb6ba7.svg";
export { ForwardRef as ReactComponent };